// extracted by mini-css-extract-plugin
module.exports = {"stimulus":"Stimulus_stimulus__26Nk-"};